const hasErrors = {
    data() {
        return {
            errors: []
        }
    },

    computed: {
        compiledErrors() {
            return this.errors.map(e => this.$t(`errors.${e.message}`, [e.field, ...e.params]))
        }
    }
}

export default hasErrors;
